import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';
import Icon from '@mui/material/Icon';
import MDBox from 'src/components/md/MDBox';
import MDTypography from 'src/components/md/MDTypography';
import MDButton from 'src/components/md/MDButton';
import type { SyncErrorState } from './types';

export interface SyncErrorDialogProps {
  syncErrorState: SyncErrorState;
  onClose: () => void;
}

export function SyncErrorDialog({
  syncErrorState,
  onClose,
}: SyncErrorDialogProps) {
  const { isOpen, message, erpSystemName } = syncErrorState;

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderTop: '4px solid #f44336',
          borderRadius: '4px',
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
        },
      }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <MDBox display="flex" alignItems="center">
          <Icon sx={{ mr: 1, fontSize: '24px' }} color="error">
            error_outline
          </Icon>
          <MDTypography variant="h6" color="error" fontWeight="medium">
            Failed to Sync to {erpSystemName || 'ERP'}
          </MDTypography>
        </MDBox>
      </DialogTitle>
      <DialogContent sx={{ pt: 0, pb: 2 }}>
        <MDBox
          sx={{
            backgroundColor: 'rgba(244, 67, 54, 0.08)',
            p: 2,
            borderRadius: '4px',
            border: '1px solid rgba(244, 67, 54, 0.2)',
            mt: 1,
          }}
        >
          <MDTypography
            variant="body2"
            sx={{
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              fontFamily: 'monospace',
              fontSize: '0.8rem',
              lineHeight: 1.5,
            }}
          >
            {message}
          </MDTypography>
        </MDBox>
      </DialogContent>
      <DialogActions>
        <MDButton variant="text" color="error" onClick={onClose}>
          Close
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
